const initialState = {};
const databaseCompaniesReducer = (state = initialState, action) => {
  switch (action.type) {
    case "storeDatabaseCompanies":
      return { ...state, databaseInfo: action.payload };
    default:
      return state;
  }
};
export default databaseCompaniesReducer;
